import axios from 'axios';
import qs from 'query-string';
import { merge } from 'lodash-es';

import env from 'environments';
import { getItem } from 'modules/dashboard/utils/legacy';

const instance = axios.create({
  baseURL: env.SCHEDULER_SERVICES_URL,
  paramsSerializer: qs.stringify,
});

instance.interceptors.request.use((config) => {
  const token = getItem('token');
  const Authorization = `Bearer ${token}`;

  return merge({}, config, {
    headers: {
      Authorization,
    },
  });
});

export const getInstance = () => instance;
